/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".message-container[_ngcontent-%COMP%]{display:flex;color:#fff;justify-content:space-between;align-items:center}.message-content[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#fff;text-decoration:underline}.message-title[_ngcontent-%COMP%]{font-family:Calibre-Light;font-size:12px;text-transform:uppercase;padding-bottom:5px}.message-body[_ngcontent-%COMP%]{font-family:Calibre-Medium;font-size:15px}"];
export { styles as styles };

